import { render, staticRenderFns } from "./itemGroup.vue?vue&type=template&id=3e09247e"
import script from "./itemGroup.vue?vue&type=script&lang=js"
export * from "./itemGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e09247e')) {
      api.createRecord('3e09247e', component.options)
    } else {
      api.reload('3e09247e', component.options)
    }
    module.hot.accept("./itemGroup.vue?vue&type=template&id=3e09247e", function () {
      api.rerender('3e09247e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/itemGroup.vue"
export default component.exports